import get from 'lodash/get'
import moment, { Moment } from 'moment'

import { DaysTree } from 'modules/timeoff/lib/getDateRangeFromTree'

interface Props {
  blockedPeriods: DaysTree
  existingLeaves: DaysTree
  bulkAdd?: boolean
  isHourlyRequest?: boolean
  daysToDisable: DaysTree
}

export const useEnableDay =
  ({ blockedPeriods, existingLeaves, bulkAdd, isHourlyRequest, daysToDisable }: Props) =>
  (date: Date | Moment): boolean => {
    if (!blockedPeriods || !existingLeaves || bulkAdd || isHourlyRequest) return true
    const momentDay = moment(date)
    return !get(
      daysToDisable,
      [momentDay.year(), momentDay.month() + 1, momentDay.date()].join('.')
    )
  }
